// Ownership signal for auth-class failures.
//
// Auth observers and the task facility must not import each other's domain, yet exactly
// one of them may report a failure. When an auth observer disposes of a failure - by
// warning, redirecting, or deliberately staying silent - it claims the error here. The
// task facility rethrows claimed failures without displaying them. Failures that never
// met an observer (raw preload fetches, direct calls) arrive unclaimed and display as usual.

const claimed = Symbol('auth-claimed')

export const claimAuthError = (error: any) => {

    if (error && typeof error === 'object')
        error[claimed] = true

    return error

}

export const isAuthErrorClaimed = (error: any): boolean => !!error?.[claimed]
